module.exports = __webpack_public_path__ + "static/media/eseal-ecs-lb-486270027.ef456e2b.png";